import React from 'react'
import ConfirmDialog from '../../../components/ConfirmDialog'

interface ConfirmArchiveDialogProps {
  open: boolean
  title: string
  message: string
  loading?: boolean
  onCancel: () => void
  onConfirm: () => void
}

/**
 * Confirmation dialog used before archiving (soft-deleting) an entity.
 * Stays open while the archive mutation is in flight; the caller closes it
 * from onCompleted.
 */
export const ConfirmArchiveDialog = ({
  open,
  title,
  message,
  loading,
  onCancel,
  onConfirm,
}: ConfirmArchiveDialogProps) => (
  <ConfirmDialog
    open={open}
    title={title}
    body={message}
    confirmText="Archive"
    confirmColor="error"
    closeOnConfirm={false}
    loading={loading}
    disableActions={loading ?? false}
    close={onCancel}
    confirm={onConfirm}
  />
)

export default ConfirmArchiveDialog
